import ApiService from "@Src/services/ApiService";
import { USER_PROFILE_API_ROUTES } from "./UserProfile.api.constant";
import { Editprofileintrfc , UpdatePasswordInterface  , UpdateCoursePreferncesIntere} from "../Interfaces/Userprofile.interface";
import { store } from "@Src/app/store";
import { isLoggedIn } from "@Src/utils/service/app.utility.service";

export async function getUserDetails() { // need to define proper interface
    return await ApiService.fetchData({
        url: USER_PROFILE_API_ROUTES.USER_DETAILS,
        method: "get",
        params:''
    });
}


export async function UpdateuserProfile(Editprofile:Editprofileintrfc) {
    return await ApiService.fetchData({
        url: USER_PROFILE_API_ROUTES.USER_DETAILS,
        method:'post',
        data:Editprofile
    });
}


export async function getCouresePreferences() {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.COURSE_PREFERNCE,
        method:'get',
        params:''
    })
    
}

export async function UpdatePassword(updatepassword:UpdatePasswordInterface) {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.PASSWORD,
        method:'put',
        data:updatepassword
    })
    
}

export async function getBoardlist() {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.BOARD_LIST,
        method:'get',
        params:''
    })
    
}

export async function getClassList(params:any) {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.CLASS_LIST,
        method:'get',
        params:params
    })
    
}
export async function getSubjectList(params:any) {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.SUBJECT_LIST,
        method:'get',
        params:params
    })    
}

export async function getEducationalInterest() {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.EDUCATIONAL_INTEREST,
        method:'get',
        params:''
    })
    
}

export async function UpdateCoursePrefernces(editcourse:Partial<UpdateCoursePreferncesIntere>) {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.UPDATE_COURSE_PREFER,
        method:'put',
        data:editcourse
    })
    
    
}

export async function getLanguageList() {
    let instituteId:any=null;
    if(isLoggedIn()) {
        try {
            const response = await getUserDetails();
            if(response?.ResponseType === "SUCCESS" && response?.data?.length > 0) {
                instituteId = response.data[0].InstituteId;
            }
        } catch (error) {
            console.log(error);
        }
    }
    
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.LANGUAGE_LIST,
        method:'get',
        params:instituteId?{instituteId:instituteId}:''
    })
}

export async function updateUserDetails(data: any) {
    return await ApiService.fetchData({
        url:USER_PROFILE_API_ROUTES.USER_DETAILS,
        method:'post',
        data:data
    })
}

export async function uploadProfileImage(imageFile: Blob) {
    const formData = new FormData();
    formData.append('ProfileImage', imageFile);
    
    return await ApiService.fetchData({
        url: 'user/profileImage',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export async function updateLanguage(languageId: number) {
    return await ApiService.fetchData({
        url: USER_PROFILE_API_ROUTES.UPDATE_LANGUAGE,
        method: 'post',
        data: { LanguageId: languageId }
    });
}